import cn from "classnames";
import styles from "./Icon.module.scss";

export const Icon = ({ className, icon }: {
  className?: string;
  icon: string | React.FunctionComponent<React.SVGAttributes<SVGElement>>;
}) => {
  return (
    <div className={cn(className, styles.icon)}>
      {typeof icon === "string" && (
        <img alt="icon" src={icon} />
      )}
      {typeof icon === "function" && icon({})}
    </div>
  )
}
